import type { ReactNode } from 'react';
import { HelpCircle } from 'lucide-react';
import {
  PHONE_NUMBER_DISCLOSURE_LABEL,
  getPhoneNumberDisclosure,
  type PhoneNumberPurpose,
} from '@court-sync/shared';
import { FieldLabel } from './Field';
import { Tooltip } from './Tooltip';
import { cn } from '@/lib/utils';

export type PhoneNumberLabelProps = {
  htmlFor?: string;
  children: ReactNode;
  required?: boolean;
  purpose?: PhoneNumberPurpose;
  className?: string;
};

export function PhoneNumberLabel({
  htmlFor,
  children,
  required,
  purpose = 'general',
  className,
}: PhoneNumberLabelProps) {
  const disclosure = getPhoneNumberDisclosure(purpose);

  return (
    <div className={cn('flex flex-wrap items-center gap-x-2 gap-y-0.5', className)}>
      <FieldLabel htmlFor={htmlFor} className="w-auto">
        {children}
        {required ? ' *' : ''}
      </FieldLabel>
      <Tooltip content={disclosure} side="top">
        <button
          type="button"
          className="inline-flex items-center gap-1 text-xs font-normal text-muted-foreground underline decoration-dotted underline-offset-2 hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary-500 rounded-sm"
          aria-label={PHONE_NUMBER_DISCLOSURE_LABEL}
        >
          <HelpCircle className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span>{PHONE_NUMBER_DISCLOSURE_LABEL}</span>
        </button>
      </Tooltip>
    </div>
  );
}
